var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "mail-message" } }, [
    _c(
      "div",
      { staticClass: "sc-message--text", on: { click: _vm.openModal } },
      [
        _c("span", { staticClass: "material-icons mail-icon" }, [
          _vm._v("chat"),
        ]),
        _vm._v(" "),
        _c("span", [
          _c("div", { staticClass: "subject" }, [
            _vm._v(_vm._s(_vm.$t("auto.smsSent"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _vm._v(_vm._s(_vm.message.data.text)),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }